import { Address, FoehnRecapSection, FoehnRecapSectionElement } from '@dsivd/prestations-ng';

export class ImpFoehnRecapSectionElement implements FoehnRecapSectionElement {
    key: string;
    value: Address | string | number;

    constructor(key: string, value: string) {
        this.key = key;
        this.value = value;
    }
}

export class ImpFoehnRecapSection implements FoehnRecapSection {
    elements: ImpFoehnRecapSectionElement[] = [];
    titleKey: string;

    constructor(title: string) {
        this.titleKey = title;
    }
}
